
import React from 'react';
import { Mail, Calendar, Linkedin, Twitter } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer id="cta" className="relative pt-32 pb-16 px-6 overflow-hidden">
      {/* Background visual highlight */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-emerald-600/10 blur-[120px] rounded-full -z-10"></div>
      
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-7xl font-bold text-white mb-8 tracking-tight">
          Stop Hiring More Hands. <br />
          <span className="text-emerald-500">Start Building Better Systems.</span>
        </h2>
        
        <p className="text-slate-400 text-lg md:text-xl mb-12 max-w-2xl mx-auto leading-relaxed">
          You don't need another salesperson doing manual entry. You need a revenue engine that works while you sleep. I am currently open to projects with forward-thinking teams in Lagos and globally.
        </p>
        
        <div className="flex flex-col items-center gap-8">
          <button 
            data-cal-namespace="gtm-audit-revenue-bottleneck-identification"
            data-cal-link="gbenlandia/gtm-audit-revenue-bottleneck-identification"
            data-cal-config='{"layout":"month_view","theme":"dark"}'
            className="group px-10 py-5 bg-white text-slate-950 hover:bg-emerald-400 transition-all rounded-full font-bold text-lg flex items-center gap-3 transform hover:scale-105"
          >
            <Calendar size={20} /> Book a Discovery Call
          </button>
          
          <div className="flex items-center gap-4 text-slate-400 hover:text-white transition-colors">
            <Mail size={18} />
            <a href="mailto:mike@mokan.name.ng" className="font-mono underline decoration-emerald-500/30 underline-offset-4">
              mike@mokan.name.ng
            </a>
          </div>
        </div>
        
        <div className="mt-32 pt-16 border-t border-slate-900 flex flex-col md:flex-row justify-between items-center gap-8 text-slate-500 text-sm">
          <div className="font-bold tracking-tighter text-white">
            GBENLANDIA<span className="text-emerald-500">.</span>
          </div>
          
          <div className="flex items-center gap-8 uppercase tracking-widest font-medium">
            <a href="#" className="hover:text-emerald-400 transition-colors flex items-center gap-2"><Linkedin size={16} /> LinkedIn</a>
            <a href="#" className="hover:text-emerald-400 transition-colors flex items-center gap-2"><Twitter size={16} /> Twitter</a>
          </div>
          
          <div className="font-mono text-xs">
            © {new Date().getFullYear()} GBENGA MICHAEL OLAIBI
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
